import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

export class ErrorItem {
    ID: number;
    JSONRequest: string;
    ErrorStack: string;
    ErrorSource: string;
    ErrorMessage: string;
    User: string;
    ApplicationName: string;
    DateCreated: Date;

    public static FixDate(item: ErrorItem) {
        item.DateCreated = new Date(item.DateCreated);
    }
}

export class ErrorItemArray extends Array<ErrorItem>  {
    public LastSort = new SortItem;

    constructor(...items: ErrorItem[]) {
        super(...items);
        Object.setPrototypeOf(this, ErrorItemArray.prototype);
    }


    public static FixDates(items: ErrorItemArray) {
        items.forEach(x => ErrorItem.FixDate(x));
    }

}
